
import Vue from "vue";
import AppProductEdit from "@/components/products/ProductEdit.vue";
import { ICreateProductModalOptions, IModal } from "@/services/modal-service";
import { Product } from "@/models/base";

export default Vue.extend({
	data(){
		return {
			product: new Product(),
			options: {} as ICreateProductModalOptions
		};
	},
	props: {
		modal: {
			type: Object as ()=>IModal,
			required: true
		}
	},
	methods: {
		onProduct(product:Product){
			this.product = product;
		},
		close(){
			this.$emit("close", this.product);
			if (this.modal.callback){
				if (this.product.ID == 0){
					this.modal.callback(null);
				}else{
					this.modal.callback(this.product);
				}
			}
		}
	},
	created(){
		let data = this.modal.data as {
			product?:Product;
			options:ICreateProductModalOptions;
		};
		if (data.product){
			this.product = data.product;
		}
		this.options = data.options;
	},
	components: {
		AppProductEdit
	}
});
